// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
import { Link } from "react-router-dom";

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.subHeaderTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb">
                <div className="container-fluid w-special">
                    <h2 dangerouslySetInnerHTML={{ __html: t('servicesPage.title') as string }} className="mb-4" />
                    <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string }} />
                    <ol className="row">
                        <li className="col-12 col-xl-6 mb-4 pr-xl-5">
                            <h3>{t('servicesPage.service1.title')}</h3>
                            <p className="mb-2">{t('servicesPage.service1.para')}</p>
                            <ul>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service1.title1')}</strong>:
                                    {t('servicesPage.service1.para1')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service1.title2')}</strong>:
                                    {t('servicesPage.service1.para2')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service1.title3')}</strong>:
                                    {t('servicesPage.service1.para3')}
                                </li>
                            </ul>
                        </li>
                        <li className="col-12 col-xl-6 mb-4 pr-xl-5">
                            <h3>{t('servicesPage.service2.title')}</h3>
                            <p className="mb-2">{t('servicesPage.service2.para')}</p>
                            <ul>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service2.title1')}</strong>:
                                    {t('servicesPage.service2.para1')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service2.title2')}</strong>:
                                    {t('servicesPage.service2.para2')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service2.title3')}</strong>:
                                    {t('servicesPage.service2.para3')}
                                </li>
                            </ul>
                        </li>
                        <li className="col-12 col-xl-6 mb-4 pr-xl-5">
                            <h3>{t('servicesPage.service3.title')}</h3>
                            <p className="mb-2">{t('servicesPage.service3.para')}</p>
                            <ul>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service3.title1')}</strong>:
                                    {t('servicesPage.service3.para1')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service3.title2')}</strong>:
                                    {t('servicesPage.service3.para2')}
                                </li>
                                <li className="mb-3">
                                    <strong>{t('servicesPage.service3.title3')}</strong>:
                                    {t('servicesPage.service3.para3')}
                                </li>
                            </ul>
                        </li>
                        <li className="col-12 col-xl-6 mb-4 pr-xl-5">
                            <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para2') as string }} />
                            <Link to="/contatti" title={t('servicesPage.btnTitle') as string} className="btn btn-primary">
                                {t('servicesPage.btnText')}
                            </Link>
                            <img src="/assets/images/dots.png" alt="dots" className="dots-image"/>
                        </li>
                    </ol>
                </div>
            </main>
        </>
    );
};

export default Services;